// Core packages
import { formatDate } from "@angular/common";
import {
  AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild
} from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";

// Third party packages
import {
  MatDialog, MatOptionSelectionChange, MatPaginator, MatSort
} from "@angular/material";
import { FormlyFieldConfig, FormlyFormOptions } from "@ngx-formly/core";
import { TranslateService } from "@ngx-translate/core";
import * as FileSaver from "file-saver";
import { MatProgressButtonOptions } from "mat-progress-buttons";
import moment from "moment";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { combineLatest, forkJoin, merge, Subscription } from "rxjs";
import {
  debounceTime, distinctUntilChanged, finalize, startWith,
  tap
} from "rxjs/operators";


// Custom packages
import { PlatformNoteCardComponent } from 'src/app/components/platform-note-card/platform-note-card.component';
import { PlatformNotesService } from "src/app/components/platform-note-card/platformNotes.service";
import { PropertySuppliersInOutService } from "src/app/modules//properties/propertySuppliersInOut.service";
import { AuthService } from "src/app/modules/auth/auth.service";
import { CompaniesService } from "src/app/modules/companies/companies.service";
import { CondoStructuresService } from "src/app/modules/properties/condo-structures.service";
import DocumentTypeStructure from "src/app/modules/properties/documentTypes";
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { PropertyTagNfcsService } from 'src/app/modules/properties/propertyTagNfcs.service';
import { SubscriptionsService } from "src/app/modules/subscriptions/subscriptions.service";
import { SuppliersService } from "src/app/modules/suppliers/suppliers.service";
import { UsersService } from "src/app/modules/users/users.service";
import { Company } from "src/app/shared/models/company/company.model";
import { IPrice } from "src/app/shared/models/price/price.interface";
import { PropertyInterface } from "src/app/shared/models/property/property.interface";
import { Property } from "src/app/shared/models/property/property.model";
import { IArchediSubscription } from "src/app/shared/models/subscription/subscription.interface";
import { IUser } from "src/app/shared/models/user/user.interface";
import { User } from "src/app/shared/models/user/user.model";
import { DateTimeFormatPipe } from "src/app/shared/pipes/date-format.pipe";
import { ApiService } from "src/app/shared/services/api.service";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
import { ListsService } from "src/app/shared/services/lists.service";
import { ThemeService } from "src/app/shared/services/theme.service";
import { PropertySuppliersInOutDataSource } from "src/app/shared/utils/data-sources/property-suppliers-in-out-source";
import { InfoDialogComponent } from "src/app/shared/components/dialogs/info-dialog/info-dialog.component";
import {
  SupplierInOutOperatorOption,
  SupplierInOutSupplierOption,
} from "src/app/shared/interfaces/supplier-in-out-filter-options.interface";

@Component({
  selector: "app-property-property-tag-nfc-list",
  templateUrl: "./property-property-tag-nfc-list.page.html",
  styleUrls: ["./property-property-tag-nfc-list.page.scss"],
})
export class PropertyPropertyPropertyTagNfcList
  implements OnInit, AfterViewInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  @ViewChild('propertyNotes', { static: false }) propertyNotes: PlatformNoteCardComponent;

  loggedUser: IUser;
  loggedUserPermissions: string[];
  loggedUserRole: any;
  currentRole: any;
  lang = this.translateService.currentLang || this.translateService.defaultLang;
  // Could not be "Property" type because in "get" method in the back-end
  // We are populating some fields, so the model is not the same!
  public property: Property = new Property();
  propertyData: PropertyInterface;
  propertyId = this.activatedRoute.snapshot.params.propertyId;
  companyId = '';

  loggedUserShared = false;
  loggedUserMaster = false;
  loggedUserAdmin = false;
  detailCardIsLoading = true;
  deleteCardIsLoading = true;
  sharedUserCardIsLoading = true;
  phonebookCardIsLoading = true;
  propertyTagNfcCardIsLoading = false;
  propertySuppliersInOutCardIsLoading = true;

  loggedUserRoleType = "";

  subscriptionDocumentUpload = false;
  masterOnlySuppliersAndNfcTag = false;
  masterOnlySuppliers = false;
  masterOnlyNfcTag = false;

  dateTimeFormat: DateTimeFormatPipe;

  masterStarDateSupplier: Date;
  masterEndDateSupplier: Date;
  masterSuppliersFee: number;

  // BEGIN - Edit property form
  // BEGIN - ngx-formly
  form: FormGroup = new FormGroup({});
  formSC: FormGroup = new FormGroup({});
  formSP: FormGroup = new FormGroup({});
  model: any = {};
  modelSC: any = {};
  modelSP: any = {};
  anagraphicFields: FormlyFieldConfig[] = [];
  contractFields: FormlyFieldConfig[] = [];
  fieldsPrices: FormlyFieldConfig[];
  statusFields: FormlyFieldConfig[] = [];
  options: FormlyFormOptions = {};

  formSharedUser: FormGroup = new FormGroup({});
  modelSharedUser: any = {};
  sharedUserFields: FormlyFieldConfig[] = [];
  optionsSharedUser: FormlyFormOptions = {};
  // END - ngx-formly
  formBtnOptions: MatProgressButtonOptions = {
    active: false,
    text: this.translateService.instant("common.cta.save"),
    spinnerSize: 19,
    raised: true,
    stroked: true,
    flat: false,
    fab: false,
    buttonColor: "primary",
    spinnerColor: "primary",
    fullWidth: false,
    disabled: false,
    mode: "indeterminate",
    buttonIcon: {
      fontSet: "fal",
      fontIcon: "fa-save",
      inline: true,
    },
  };
  formSharedUserBtnOptions: MatProgressButtonOptions = {
    active: false,
    text: this.translateService.instant("common.cta.save"),
    spinnerSize: 19,
    raised: true,
    stroked: true,
    flat: false,
    fab: false,
    buttonColor: "primary",
    spinnerColor: "primary",
    fullWidth: false,
    disabled: false,
    mode: "indeterminate",
    buttonIcon: {
      fontSet: "fal",
      fontIcon: "fa-save",
      inline: true,
    },
  };
  deleteBtnOptions: MatProgressButtonOptions = {
    active: false,
    text: this.translateService.instant("common.cta.deactivate"),
    spinnerSize: 19,
    raised: true,
    stroked: true,
    flat: false,
    fab: false,
    buttonColor: "warn",
    spinnerColor: "warn",
    fullWidth: false,
    disabled: false,
    mode: "indeterminate",
    buttonIcon: {
      fontSet: "fal",
      fontIcon: "fa-times",
      inline: true,
    },
  };
  reactivateBtnOptions: MatProgressButtonOptions = {
    active: false,
    text: this.translateService.instant("common.cta.activate"),
    spinnerSize: 19,
    raised: true,
    stroked: true,
    flat: false,
    fab: false,
    buttonColor: "primary",
    spinnerColor: "primary",
    fullWidth: false,
    disabled: false,
    mode: "indeterminate",
    buttonIcon: {
      fontSet: "fal",
      fontIcon: "fa-check",
      inline: true,
    },
  };
  // END - Edit property form

  // BEGIN - Table property Suppliers In Out
  propertySuppliersInOutDisplayedColumns: string[] = [
     "index",
    "tagNfcId",
    "tagName",
    "supplierId",
    "code",
    "entrance",
    "typeIn",
    "exit",
    "typeOut",
    "duration",
  ];
  propertySuppliersInOutDataSource: PropertySuppliersInOutDataSource;
  @ViewChild("propertySuppliersInOutSort", { static: true }) propertySuppliersInOutSort: MatSort;
  @ViewChild("propertySuppliersInOutPaginator", { static: true }) propertySuppliersInOutPaginator: MatPaginator;
  @ViewChild("propertySuppliersInOutInput", { static: false }) propertySuppliersInOutInput: ElementRef;

  tagNfcIdFilter: FormControl = new FormControl("");
  tagNameFilter: FormControl = new FormControl("");
  codeFilter: FormControl = new FormControl("");
  supplierIdFilter: FormControl = new FormControl("");
  entranceFilter: FormControl = new FormControl("");
  exitFilter: FormControl = new FormControl("");
  typeInFilter: FormControl = new FormControl("");
  typeOutFilter: FormControl = new FormControl("");
  durationFilter: FormControl = new FormControl("");
  // END - Table property Tag NFC

  prices: IPrice[] = [];
  availableSubscriptions: any[];
  availableSubscriptionsKeys: any[];
  subscriptionKey = "";

  defaultStartDate: string;
  defaultEndDate: string;

  isInit = true;
  loggedUserRequestedRoleType: string;

  enableEdit = false;
  sharedUser: User = new User();

  previousPermissions = {
    unlimited: false,
    mappatura: false,
    gestionaleAmministrativo: false,
    amminImmobile: false,
    gestionaleContabile: false,
    urbanisticaEdEdilizia: false,
    catasto: false,
    contratti: false,
    lineaVita: false,
    amiantoDoc: false,
    edile: false,
    impiantoElettrico: false,
    riscaldamentoCondizionamento: false,
    ascensoriEMontauto: false,
    trattamentoAcqua: false,
    impiantiElettronici: false,
    antincendio: false,
    impiantiSpeciali: false,
    impiantiRicreativiSportivi: false,
    unitaImmobiliari: false,
    preventivi: false,
  };

  deadlinesCardIsLoading = true;
  
  public documentTypeStructure: DocumentTypeStructure =
    new DocumentTypeStructure();

  subscriptionType = "FREE";

  previousSafetyContract: any = {};
  previousAntifireContract: any = {};
  
  previousSubscription: any = {};

  availableTypes = [];

  archediSubscriptions: IArchediSubscription[] = [];

  // List of codes
  firstScanCodes = this.configService.availableScanCodes;
  firstFixedPackCodes = this.configService.availableFixedPackageCodes;
  scanInsNextCodesForfait = this.configService.availableInsCodesNextForfait;
  scanNextCodesForfait = this.configService.availableScanCodesNextForfait;

  previousTotalStorageSpaceUsed = 0;

  // Dati aggiuntivi elenco/nuovo elemento
  suppliersName: any[] = [];
  yearsOfStorage: any[] = [];
  conductorName: any[] = [];
  nameInterventionArchiving: any[] = [];

  documentTemplateId = "";
  documentTemplate: any[] = [];

  companyName = "";
  companyData = {};
  company: Company = new Company();

  mappaturaOpen = false;

  // Status card
  sagDate: FormControl = new FormControl("");
  statusCardIsLoading = true;

  supplierIdIsLoading = false;
  availableSupplierIds: any[] = [];

  // Filter dropdown options loaded from GET supplier-in-out/filter-options.
  // When the load fails (e.g. 403 because the user lacks
  // 'canReadSupplierInOutList'), filterOptionsLoaded stays false and the
  // template keeps the legacy free-text inputs for supplier/operator.
  supplierOptions: SupplierInOutSupplierOption[] = [];
  operatorOptions: SupplierInOutOperatorOption[] = [];
  // Client-side filtered views of the option lists, bound to the autocompletes.
  // Recomputed locally as the user types in the supplier/operator filter inputs.
  filteredSupplierOptions: SupplierInOutSupplierOption[] = [];
  filteredOperatorOptions: SupplierInOutOperatorOption[] = [];
  filterOptionsLoaded = false;
  filterOptionsLoading = false;

  // Max number of suggestions shown in the supplier/operator autocompletes,
  // mirroring the admin-column filter (server-capped at 10): on focus the panel
  // shows the first N options and, while typing, at most N matches — instead of
  // dumping the full property-scoped list as a single scrollable menu.
  private readonly filterOptionsDisplayLimit = 10;

  /**
   * Class constructor
   */
  constructor(
    public dialog: MatDialog,
    public newMessageDialog: MatDialog,
    public cancelContractDialog: MatDialog,
    private configService: ConfigService,
    private activatedRoute: ActivatedRoute,
    private propertiesService: PropertiesService,
    private router: Router,
    private toastrService: ToastrService,
    private helperService: HelperService,
    private translateService: TranslateService,
    private themeService: ThemeService,
    private authService: AuthService,
    private cookieService: CookieService,
    private companiesService: CompaniesService,
    private apiService: ApiService, // DO NOT MOVE since it's used for 'autocomplete' field type
    private subscriptionsService: SubscriptionsService,
    private listsService: ListsService,
    private userService: UsersService,
    private suppliersService: SuppliersService,
    private condoStructuresService: CondoStructuresService,
    private platformNotesService: PlatformNotesService,
    private propertyTagNfcsService: PropertyTagNfcsService,
    private propertySuppliersInOutService: PropertySuppliersInOutService,
  ) { }

  /**
   * Open the "Tipo lettura" (reading type) info popup
   *
   * @since 1.0.0
   */
  onInfoTypePopUp(): void {
    const width = "600px";
    const title = this.translateService.instant("propertySuppliersInOut.typeInfo.title");
    const message = this.translateService.instant("propertySuppliersInOut.typeInfo.message");
    if (title.trim() !== "") {
      this.dialog.open(InfoDialogComponent, {
        data: {
          title,
          message,
        },
        width,
        maxWidth: width,
      });
    }
  }

  /**
   * Init components
   *
   * @since 1.0.0
   */
  ngOnInit(): void {
    // Set page title
    this.themeService.setPageTitle(
      this.translateService.instant("properties.detail.pageTitle")
    );
    
    // Get logged user data
    this.subscriptions.push(
      this.authService.loggedUser$.subscribe((res) => {
        this.loggedUser = res;
        this.currentRole = this.loggedUser.userRoles.find((obj: any) => {
          return (
            obj._id.toString() ===
            this.authService.loggedUserRequestedRole$.getValue().toString()
          );
        });
        this.loggedUserRoleType = this.currentRole.role.type;
        // Get logged user's role data
        if (this.currentRole.role.type === "shared") {
          this.loggedUserShared = true;
        }
        if (
          this.currentRole.role.type === "master" ||
          this.currentRole.role.type === "collaborator"
        ) {
          this.loggedUserMaster = true;
          if (this.currentRole.company._id !== "") {
            this.subscriptions.push(
              this.companiesService
                .get(this.currentRole.company._id)
                .subscribe((res) => {
                  if (res.status) {
                    this.companyData = res.data;
                    this.company.setData(res.data);
                    if (
                      !res.data.subscription.documentUpload  && 
                      res.data.subscription.nfcAccess &&
                      res.data.subscription.suppliers
                    ) {
                      this.masterOnlySuppliersAndNfcTag = true;
                    } else if (
                      !res.data.subscription.documentUpload  && 
                      !res.data.subscription.nfcAccess &&
                      res.data.subscription.suppliers
                    ) {
                      this.masterOnlySuppliers = true;
                    } else if (
                      !res.data.subscription.documentUpload  && 
                      res.data.subscription.nfcAccess &&
                      !res.data.subscription.suppliers
                    ) {
                      this.masterOnlyNfcTag = true;
                    }
                  }
                })
            );
          }
        }
      })
    );
    this.subscriptions.push(
      this.authService.loggedUserPermissions$.subscribe(
        (res) => (this.loggedUserPermissions = res)
      )
    );

    // Get current lang
    this.lang =
      this.cookieService.get("lang") || this.configService.defaultLang;

    // Init data sources
    this.propertySuppliersInOutDataSource = new PropertySuppliersInOutDataSource(
      this.propertySuppliersInOutService,
      this.helperService
    );

    // Init areas
    this.availableTypes = this.configService.availableDocumentAreas.map(
      (element: any) => {
        return {
          value: element,
          label: this.translateService.instant(
            `properties.documents.areas.${element}`
          ),
        };
      }
    );

    // Se default start and end date
    this.defaultStartDate = moment().format("YYYY-MM-DD"); // .toISOString();
    this.defaultEndDate = moment()
      .add(1, "years")
      .subtract(1, "days")
      .format("YYYY-MM-DD"); // .toISOString();

  }

  /**
   * After view init logic
   *
   * @since 1.0.0
   */
  ngAfterViewInit(): void {
    // Get requested property data
    this.subscriptions.push(
      this.propertiesService
        .get(this.propertyId)
        .subscribe(
          (res) => {
            if (res.status) {
              // Set permission data
              this.property.setData(res.data);
              this.propertyData = JSON.parse(JSON.stringify(res.data));
              this.subscriptionKey = this.propertyData.subscription.key;
              
              this.companyId = this.property.get("admin.company._id");
              if (typeof this.companyId === "undefined") {
                this.companyId = this.property.get("admin.company");
              }

              for (const prop in res.data.subscription) {
                this.previousSubscription[prop] =
                  res.data.subscription[prop];
              }

              if (
                this.propertyData.subscription &&
                this.propertyData.subscription.key
              ) {
                this.subscriptionType = this.propertyData.subscription.key;
                if (this.propertyData.subscription.documentUpload) {
                  this.subscriptionDocumentUpload = true;
                }
              }

              if (this.propertyData.structure) {
                this.subscriptions.push(
                  this.condoStructuresService.get(this.propertyData.structure)
                    .subscribe(res => {
                      if (
                        res.status && 
                        res.data
                      ) {
                        this.mappaturaOpen = res.data.open;
                      }
                    },
                      err => {
                        this.helperService.handleError(err);
                      })
                );
              }

              // Stop loading in delete form
              this.deleteCardIsLoading = false;

              // Get form initial values and init the form
              this.getDataAndInitForm();

              return;
            }

            // Something bad happened
            // redirect user to home
            this.router.navigate([this.lang, "app", "properties", "list"]);
          },
          (err) => {
            // if we came here users with given userId do not exist
            this.router.navigate([this.lang, "errors", "404"]);
          }
        )
    );
  }

  /**
   * Handle component destroy
   *
   * @since 1.0.0
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  /**
   * Get requested initialValues for the form and than init it
   *
   * @since 1.0.0
   */
  getDataAndInitForm(): void {
    if (this.property.get("owner._id")) {
      this.subscriptions.push(
        forkJoin(
          this.companiesService.get(this.property.get("admin.company._id")),
          this.companiesService.get(this.property.get("owner._id"))
        ).subscribe((res) => {
          let initialAdminData;
          let initialOwnerData;
          if (res[0] && res[0].status) {
            initialAdminData = [res[0].data];
            this.companyName = res[0].data.name;
          }
          if (res[1] && res[1].status) {
            initialOwnerData = [res[1].data];
          }

          // Make detail form card visible by disabling his card-spinner
          this.detailCardIsLoading = false;

          this.statusCardIsLoading = false;
        })
      );
    } else {
      this.companiesService
        .get(this.property.get("admin.company._id"))
        .subscribe((res) => {
          let initialAdminData;
          if (res && res.status) {
            initialAdminData = [res.data];
            this.companyName = res.data.name;
          }

          // Make detail form card visible by disabling his card-spinner
          this.detailCardIsLoading = false;
          this.statusCardIsLoading = false;
        });
    }

    this.propertySuppliersInOutCardIsLoading = false;

    this.propertyTagNfcCardIsLoading = false;

    this.initPropertySuppliersInOutDataTable();
  }
  
  /**
   * Init property Suppliers In Out data table
   *
   * @since 1.0.0
   */
  initPropertySuppliersInOutDataTable(): void {
    // Load first set of data
    this.loadPropertySuppliersInOutPage();

    // Load supplier/operator filter dropdown options (with 403 fallback)
    this.loadFilterOptions();

    // Reset pagination after sorting
    this.subscriptions.push(
      this.propertySuppliersInOutSort.sortChange.subscribe(
        () => (this.propertySuppliersInOutPaginator.pageIndex = 0)
      )
    );

    // Once user change sorting OR change page
    // let's reload the page data
    this.subscriptions.push(
      merge(this.propertySuppliersInOutSort.sortChange, this.propertySuppliersInOutPaginator.page)
        .pipe(tap(() => this.loadPropertySuppliersInOutPage()))
        .subscribe()
    );

    // // Handle server-side filtering through general search
    // this.subscriptions.push(
    //   fromEvent(this.propertySuppliersInOutInput.nativeElement, "keyup")
    //     .pipe(
    //       debounceTime(this.configService.debounceTime), // max 1 query every 350 milliseconts
    //       distinctUntilChanged(), // Eliminate duplicate values
    //       tap(() => {
    //         this.propertySuppliersInOutPaginator.pageIndex = 0; // Reset page
    //         this.loadPropertySuppliersInOutPage();
    //       })
    //     )
    //     .subscribe()
    // );

    // Handle server-side filtering through column-specific search
    // Why do we use "null as string"? --> @see https://github.com/ReactiveX/rxjs/issues/4772
    combineLatest([
      this.tagNfcIdFilter.valueChanges.pipe(startWith(null as string)),
      this.tagNameFilter.valueChanges.pipe(startWith(null as string)),
      this.codeFilter.valueChanges.pipe(startWith(null as string)),
      this.supplierIdFilter.valueChanges.pipe(startWith(null as string)),
      this.entranceFilter.valueChanges.pipe(startWith(null as string)),
      this.exitFilter.valueChanges.pipe(startWith(null as string)),
      this.typeInFilter.valueChanges.pipe(startWith(null as string)),
      this.typeOutFilter.valueChanges.pipe(startWith(null as string)),
      this.durationFilter.valueChanges.pipe(startWith(null as string)),
    ])
      .pipe(
        debounceTime(this.configService.debounceTime), // max 1 query every 350 milliseconts
        distinctUntilChanged() // Eliminate duplicate values
      )
      .subscribe((res) => {
        // Load page only if at least one value is not null
        if (!res.every((value) => value === null)) {
          this.propertySuppliersInOutPaginator.pageIndex = 0;
          this.loadPropertySuppliersInOutPage();
        }
      });
  }

  /**
   * Load requested data page
   *
   * @since 1.0.0
   */
  loadPropertySuppliersInOutPage(): void {
    const start = this.propertySuppliersInOutPaginator.pageIndex * this.propertySuppliersInOutPaginator.pageSize;
    const length = this.propertySuppliersInOutPaginator.pageSize;
    const search = {
      general: "", // this.input.nativeElement.value,
      tagNfcId: this.tagNfcIdFilter.value,
      tagName: this.tagNameFilter.value,
      code: this.resolveFilterValue(this.codeFilter.value),
      supplierId: this.resolveFilterValue(this.supplierIdFilter.value),
      entrance: this.entranceFilter.value,
      exit: this.exitFilter.value,
      typeIn: this.typeInFilter.value,
      typeOut: this.typeOutFilter.value,
      duration: this.durationFilter.value,
    };
    this.propertySuppliersInOutDataSource.loadPropertyItems(
      this.propertyId,
      start,
      length,
      this.propertySuppliersInOutSort.active,
      this.propertySuppliersInOutSort.direction,
      search
    );
  }

  /**
   * Reset table's filters
   *
   * @since 1.0.0
   */
  onResetFiltersPropertySuppliersInOut(): void {
    // Reset lists service data
    this.listsService.setListSetting("", 0, 10, {});

    // Reset tables' filters
    // this.input.nativeElement.value = "";
    this.tagNfcIdFilter.setValue(null);
    this.tagNameFilter.setValue(null);
    this.codeFilter.setValue(null);
    this.supplierIdFilter.setValue(null);
    this.entranceFilter.setValue(null);
    this.exitFilter.setValue(null);
    this.typeInFilter.setValue(null);
    this.typeOutFilter.setValue(null);
    this.durationFilter.setValue(null);
  
    // Reset tables' sorting versus and column
    this.propertySuppliersInOutSort.direction = "asc";
    this.propertySuppliersInOutSort.active = "tagNfcId";
    this.propertySuppliersInOutSort._stateChanges.next();

    // Reset paginator
    this.propertySuppliersInOutPaginator.pageIndex = 0;
    this.propertySuppliersInOutPaginator.pageSize = 10;

    // Reload table's data
    this.loadPropertySuppliersInOutPage();
  }

  /**
   * Reset given filter value and reload the page
   *
   * @since 1.0.0
   */
  onResetFilterPropertySuppliersInOut(filter: FormControl): void {
    filter.reset();
    this.loadPropertySuppliersInOutPage();
  }
  
  /**
   * Reset general search input and dispath a 'keyup' event
   * so that the table re-render his rows
   *
   * @since 1.0.0
   */
  resetInputPropertySuppliersInOut(): void {
    // this.input.nativeElement.value = "";
    const event = new KeyboardEvent("keyup");
    // this.input.nativeElement.dispatchEvent(event);
  }

  /**
   * 
   */
  onExportPropertySuppliersInOut(): void {
    // If target is not provided, than just export all properties
    const date = formatDate(new Date(), "yyyyMMddhhmmss", "en-EN");
    const fileName = `${this.translateService.instant(
      "properties.propertySuppliersInOutList.exportPropertyFileName"
    )} ${date}`;
    this.subscriptions.push(
      this.propertySuppliersInOutService.getExportProperty(this.propertyId).subscribe(
        (res) => {
          const fileBlob = res;
          const blob = new Blob([fileBlob], {
            type: "application/vnd.ms-excel",
          });
          FileSaver.saveAs(blob, `${fileName}.xlsx`);
        },
        (err) => {
          this.helperService.handleError(err);
        }
      )
    );
  }

  /**
   * Used to handle the display of selected result
   *
   * @since 1.0.0
   *
   * @param arg Data to be displayed
   * @returns result string to display or undefined
   */
  displaySupplierIdOrOwnerFn(arg?: PropertyInterface): string | undefined {
    return arg ? `${arg.name}` : undefined;
  }

  /**
   * Handle click on a selected admin in the mat-autocomplete list and fires the loadPage()
   *
   * @since 1.0.0
   */
  onSupplierIdFilterSelected(event: MatOptionSelectionChange): void {
    const value = event.source.value;
    this.supplierIdFilter.setValue(value, { emitEvent: false });
    this.loadPropertySuppliersInOutPage();
  }

  /**
   * Get the list of available suppliers
   * used to allow filtering on property column
   *
   * @since 1.0.0
   */
  getAvailableSuppliers(search?: any): void {
    this.subscriptions.push(
      this.suppliersService
        .getList(0, 10, null, null, search)
        .pipe(
          finalize(() => {
            this.supplierIdIsLoading = false;
          })
        )
        .subscribe((res) => {
          if (res.status) {
            this.availableSupplierIds = res.data.items;
          }
        })
    );
  }

  /**
   * Load the supplier/operator filter dropdown options.
   *
   * On success the supplier and operator autocompletes are populated and replace
   * the legacy free-text inputs. A 403 (the user can read the list but lacks the
   * 'canReadSupplierInOutList' permission required by the filter-options
   * endpoint) is handled silently by keeping the free-text inputs as fallback.
   * Any other error also falls back, but is surfaced to the user.
   *
   * @since 3.0.0
   */
  loadFilterOptions(): void {
    this.filterOptionsLoading = true;
    this.subscriptions.push(
      this.propertySuppliersInOutService.getFilterOptions().subscribe(
        (options) => {
          this.supplierOptions = options.suppliers;
          this.operatorOptions = options.operators;
          this.filteredSupplierOptions = options.suppliers.slice(0, this.filterOptionsDisplayLimit);
          this.filteredOperatorOptions = options.operators.slice(0, this.filterOptionsDisplayLimit);
          this.filterOptionsLoaded = true;
          this.filterOptionsLoading = false;
          this.registerOptionFilters();
        },
        (err) => {
          // Keep the legacy free-text filters as fallback; never break the page.
          this.filterOptionsLoaded = false;
          this.filterOptionsLoading = false;
          // 403 is the expected "missing permission" case -> stay silent.
          // Any other real error is surfaced to the user.
          if (err && err.status !== 403) {
            this.helperService.handleError(err);
          }
        }
      )
    );
  }

  /**
   * Register the client-side filtering of the supplier/operator autocomplete
   * option lists. The full option set is loaded once from the backend
   * (@see loadFilterOptions) and filtered locally as the user types, mirroring
   * the admin-column autocomplete on the properties list while avoiding an extra
   * round-trip per keystroke.
   *
   * @since 3.0.0
   */
  registerOptionFilters(): void {
    this.subscriptions.push(
      this.codeFilter.valueChanges.subscribe((value) => {
        this.filteredOperatorOptions = this.filterOperatorOptions(value);
      })
    );
    this.subscriptions.push(
      this.supplierIdFilter.valueChanges.subscribe((value) => {
        this.filteredSupplierOptions = this.filterSupplierOptions(value);
      })
    );
  }

  /**
   * Filter the operator option list by the typed text (matches label or code,
   * case-insensitive). Returns the full list when nothing meaningful is typed or
   * when an option object is already selected.
   *
   * @since 3.0.0
   */
  filterOperatorOptions(value: any): SupplierInOutOperatorOption[] {
    if (!value || typeof value === "object") {
      return this.operatorOptions.slice(0, this.filterOptionsDisplayLimit);
    }
    const needle = ("" + value).toLowerCase().trim();
    if (!needle) {
      return this.operatorOptions.slice(0, this.filterOptionsDisplayLimit);
    }
    return this.operatorOptions
      .filter((option) => {
        const label = (option.label || "").toLowerCase();
        const code = (option.code || "").toLowerCase();
        return label.indexOf(needle) !== -1 || code.indexOf(needle) !== -1;
      })
      .slice(0, this.filterOptionsDisplayLimit);
  }

  /**
   * Filter the supplier option list by the typed text (matches label,
   * case-insensitive). Returns the full list when nothing meaningful is typed or
   * when an option object is already selected.
   *
   * @since 3.0.0
   */
  filterSupplierOptions(value: any): SupplierInOutSupplierOption[] {
    if (!value || typeof value === "object") {
      return this.supplierOptions.slice(0, this.filterOptionsDisplayLimit);
    }
    const needle = ("" + value).toLowerCase().trim();
    if (!needle) {
      return this.supplierOptions.slice(0, this.filterOptionsDisplayLimit);
    }
    return this.supplierOptions
      .filter((option) => {
        const label = (option.label || "").toLowerCase();
        return label.indexOf(needle) !== -1;
      })
      .slice(0, this.filterOptionsDisplayLimit);
  }

  /**
   * Display function for the operator autocomplete: shows the operator label
   * (plus its code when it differs) for a selected option, or the raw string
   * while the user is still typing / when a plain value was restored.
   *
   * @since 3.0.0
   */
  displayOperatorFn(option?: SupplierInOutOperatorOption | string): string | undefined {
    if (!option) {
      return undefined;
    }
    if (typeof option === "string") {
      return option;
    }
    if (option.code && option.code !== option.label) {
      return option.code;
    }
    return option.label;
  }

  /**
   * Display function for the supplier autocomplete: shows the supplier label for
   * a selected option, or the raw string while the user is still typing / when a
   * plain value was restored.
   *
   * @since 3.0.0
   */
  displaySupplierFn(option?: SupplierInOutSupplierOption | string): string | undefined {
    if (!option) {
      return undefined;
    }
    if (typeof option === "string") {
      return option;
    }
    return option.label;
  }

  /**
   * Handle selection of an operator from the autocomplete. Stores the selected
   * option object on the control (without re-emitting, to avoid a duplicate
   * server reload) and reloads the first page.
   *
   * @since 3.0.0
   */
  onOperatorFilterSelected(event: MatOptionSelectionChange): void {
    if (!event || !event.isUserInput) {
      return;
    }
    this.codeFilter.setValue(event.source.value, { emitEvent: false });
    this.propertySuppliersInOutPaginator.pageIndex = 0;
    this.loadPropertySuppliersInOutPage();
  }

  /**
   * Handle selection of a supplier from the autocomplete. Stores the selected
   * option object on the control (without re-emitting, to avoid a duplicate
   * server reload) and reloads the first page.
   *
   * @since 3.0.0
   */
  onSupplierFilterSelected(event: MatOptionSelectionChange): void {
    if (!event || !event.isUserInput) {
      return;
    }
    this.supplierIdFilter.setValue(event.source.value, { emitEvent: false });
    this.propertySuppliersInOutPaginator.pageIndex = 0;
    this.loadPropertySuppliersInOutPage();
  }

  /**
   * Resolve a supplier/operator filter control value into the value sent to the
   * backend as search[supplierId] / search[code].
   *
   * - A selected autocomplete option (object) yields its id.
   * - Partial typed text while the autocomplete is active yields null (no
   *   filtering until an option is actually picked, as on the admin column);
   *   null params are stripped by ApiService.
   * - When the filter-options endpoint is unavailable (legacy free-text
   *   fallback) the raw string is forwarded as before.
   *
   * @since 3.0.0
   */
  resolveFilterValue(value: any): any {
    if (value && typeof value === "object") {
      return value.id;
    }
    if (this.filterOptionsLoaded) {
      return null;
    }
    return value;
  }
}
